exports.getSettings = hasVideoViews => ({
    calloutSettings: hasVideoViews ? [
        { key: 'video_views', title: 'Video Views', format: '0,0' },
        { key: 'conversions', title: 'Conversions', format: '0,0' },
        { key: 'video_view_rate', title: 'Video View Rate', format: '0,0.00%' },
        { key: 'cpvv', title: 'CPVV', format: '$0,0.00' },
    ] : [
        { key: 'clicks', title: 'Clicks', format: '0,0' },
        { key: 'cpc', title: 'CPC', format: '$0,0.00' },
        { key: 'conversions', title: 'Conversions', format: '0,0' },
        { key: 'ctr', title: 'CTR', format: '0,0.00%' },
    ],
    twoAxisChart: {
        title: hasVideoViews ? 'VIDEO VIEWS VS. VIDEO VIEW RATE' : 'CLICKS VS. CTR',
        yBar: hasVideoViews ? 'video_views' : 'clicks',
        yBarTitle: hasVideoViews ? 'Video Views' : 'Clicks',
        yLine: hasVideoViews ? 'video_view_rate' : 'ctr',
        yLineTitle: hasVideoViews ? 'Video View Rate' : 'CTR',
    },
    commonKeys: hasVideoViews ? [{ key: 'video_views' }, { key: 'clicks' }] : [{ key: 'clicks' }, { key: 'conversions' }],
    tableType: hasVideoViews ? 'youtubeVideoViews' : 'youtube'
});



// WEBPACK FOOTER //
// ./src/helpers/youtube.js